export default {
  // Region Selector
  "region.hello": "Hello! You are being directed to the",
  "region.continue": "You can continue on the current site or go to your country's local site.",
  "region.region": "Region",
  "region.goTo": "Go to",
  "region.stayIn": "Stay in",
  "region.change": "Change region",
  "region.detecting": "Detecting your location...",
  "region.selectCountry": "Select your country or region",
  "region.searchPlaceholder": "Search country or region...",
  "region.noResults": "No results found",
  "region.detected": "Detected",
  "region.close": "Close",
  "region.changeSelection": "Change selection",
  "region.spanish": "Spanish",
  "region.english": "English",
  "continent.Americas": "Americas",
  "continent.Europe": "Europe",
  "continent.Asia": "Asia",
  "continent.Africa": "Africa",
  "continent.Oceania": "Oceania",
  "continent.Global": "Global",

  // Hero
  "hero.tag1": "CSOC 24/7",
  "hero.title1": "We protect your",
  "hero.highlight1": "digital future",
  "hero.subtitle1": "World-class cybersecurity solutions for companies that demand the highest level of protection",
  "hero.cta1": "Explore solutions",
  "hero.secondary1": "Request demo",
  "hero.tag2": "AI-Powered",
  "hero.title2": "Artificial intelligence",
  "hero.highlight2": "against threats",
  "hero.subtitle2": "Cyber intelligence platform with machine learning that detects and neutralizes attacks in real time",
  "hero.cta2": "View platform",
  "hero.secondary2": "Success stories",
  "hero.tag3": "Zero Trust",
  "hero.title3": "Fortified",
  "hero.highlight3": "infrastructure",
  "hero.subtitle3": "Multi-layer protection for cloud environments, endpoints and corporate networks with continuous monitoring",
  "hero.cta3": "Cloud Services",
  "hero.secondary3": "Consulting",
  "hero.tag4": "Global Presence",
  "hero.title4": "America and Europe",
  "hero.highlight4": "one mission",
  "hero.subtitle4": "No limits, with presence in countries like USA, Peru, Chile, Colombia, Ecuador, Mexico and Europe with certified SOCs and outstanding 4.5/5 ratings",
  "hero.cta4": "About us",
  "hero.secondary4": "Find us",
  "hero.verCybersoc": "View CyberSOC",
  "hero.videoPlaying": "Now Playing",
  "hero.videoDesc": "See how we protect critical infrastructure in real time",
  "hero.scroll": "Scroll",

  // Stats
  "stat.countries": "Presence",
  "stat.rating": "SOC Rating",
  "stat.iso": "27001:2013",
  "stat.monitoring": "Monitoring",

  // Navbar
  "nav.home": "Home",
  "nav.about": "About Us",
  "nav.solutions": "Solutions",
  "nav.services": "Services",
  "nav.trainings": "Secure Academy",
  "nav.datacenter": "Datacenter",
  "nav.contact": "Contact us",
  "nav.support": "Support",
  "nav.quote": "Can we help you?",
  "nav.cybersoc": "CyberSOC",

  // Nav dropdowns - About
  "nav.dropdown.vision": "Vision & Mission",
  "nav.dropdown.milestones": "Milestones",
  "nav.dropdown.recognitions": "Recognitions",

  // Nav dropdowns - Solutions
  "nav.dropdown.dataSecurity": "Data Security",
  "nav.dropdown.endpointSecurity": "Endpoint Security",
  "nav.dropdown.cloudSecurity": "Cloud Security",
  "nav.dropdown.appSecurity": "Application Security",
  "nav.dropdown.netSecurity": "Networking Security",
  "nav.dropdown.cyberintel": "Cyber Intelligence",

  // Nav dropdowns - Services
  "nav.dropdown.consulting": "Security Consulting",
  "nav.dropdown.securityConsulting": "Cybersecurity Consulting",
  "nav.dropdown.cybersoc": "CyberSOC 24/7/365",
  "nav.dropdown.productEng": "Product Engineering",
  "nav.dropdown.secureAcademy": "Secure Academy",

  // Nav dropdowns - Datacenter
  "nav.dropdown.dcInfra": "Data Center & Infrastructure",
  "nav.dropdown.dcCloud": "Cloud Services",
  "nav.dropdown.dcSecurity": "Security Services",
  "nav.dropdown.dcNetwork": "Networks & Communications",
  "nav.dropdown.dcCyber": "Cybersecurity",
  "nav.dropdown.dcManaged": "Managed Services (SOC/NOC)",
  "nav.dropdown.dcDatabase": "Databases & Backup",
  "nav.dropdown.dcBCDR": "Business Continuity & Disaster Recovery",
  "nav.dropdown.dcSales": "Software/Hardware Sales & Rental",
  "nav.dropdown.dcProjectConsulting": "Project Consulting",

  // Solutions cards
  "sol.dataSecurity.subtitle": "Critical data protection with advanced encryption, data loss prevention (DLP) and regulatory compliance.",
  "sol.endpointSecurity.subtitle": "Advanced endpoint protection with EDR/XDR, intrusion prevention and automated response.",
  "sol.cloudSecurity.subtitle": "Comprehensive protection for AWS, Azure and GCP. Container security, DevSecOps and multi-cloud compliance.",
  "sol.appSecurity.subtitle": "DevSecOps, SAST/DAST, secure code review and API protection for a secure development lifecycle.",
  "sol.netSecurity.subtitle": "Network segmentation, Next-Gen Firewall, IDS/IPS and network attack protection with Zero Trust architecture.",
  "sol.cyberintel.title": "Cyber Intelligence",
  "sol.cyberintel.subtitle": "Proactive threat intelligence, dark web monitoring, indicators of compromise (IoC) and threat actor analysis.",

  // Services cards
  "svc.consulting.title": "Security Consulting",
  "svc.consulting.subtitle": "Specialized advisory to strengthen your organization's security posture with proven methodologies.",
  "svc.securityConsulting.title": "Cybersecurity Consulting",
  "svc.securityConsulting.subtitle": "Advanced technical services in ethical hacking, pentesting and forensic analysis to identify vulnerabilities.",
  "svc.cybersoc.title": "CyberSOC 24/7/365",
  "svc.cybersoc.subtitle": "Managed Security Operations Center 24/7 with continuous monitoring, threat detection and incident response.",
  "svc.productEng.title": "Product Engineering",
  "svc.productEng.subtitle": "Implementation, technical support and remote administration of top-tier security solutions.",
  "svc.secureAcademy.title": "Secure Academy",
  "svc.secureAcademy.subtitle": "Official certification programs and specialized cybersecurity training with certified instructors.",

  // Services items
  "svc.consulting.item1": "Technology Security & Network Assessment",
  "svc.consulting.item2": "Information Security Assessment",
  "svc.consulting.item3": "Information Classification",
  "svc.consulting.item4": "Security Awareness",
  "svc.consulting.item5": "ISMS Implementation",
  "svc.consulting.item6": "Personal Data Protection Law Compliance",
  "svc.consulting.item7": "PCI Compliance",
  "svc.consulting.item8": "Risk Analysis",
  "svc.consulting.item9": "Cybersecurity Assessment",
  "svc.consulting.item10": "Disaster Recovery Plan (DRP)",
  "svc.consulting.item11": "Business Continuity Plan (BCP)",
  "svc.consulting.item12": "ISO 27001 Certification Advisory",

  "svc.securityConsulting.item1": "Hardening Assessment",
  "svc.securityConsulting.item2": "Ethical Hacking on ATMs",
  "svc.securityConsulting.item3": "Ethical Hacking Training",
  "svc.securityConsulting.item4": "Ethical Hacking",
  "svc.securityConsulting.item5": "Vulnerability Analysis",
  "svc.securityConsulting.item6": "Penetration Test",
  "svc.securityConsulting.item7": "SCADA Security",
  "svc.securityConsulting.item8": "Forensic Analysis",
  "svc.securityConsulting.item9": "Red Team",
  "svc.securityConsulting.item10": "Source Code Analysis",
  "svc.securityConsulting.item11": "Wireless Network Assessment",
  "svc.securityConsulting.item12": "Threat Hunting",

  "svc.cybersoc.item1": "Platform Health Monitoring & Notification",
  "svc.cybersoc.item2": "Security Event Monitoring & Correlation Notification",
  "svc.cybersoc.item3": "Cyber Intelligence",
  "svc.cybersoc.item4": "External Threat Monitoring - Security Bulletins",

  "svc.productEng.item1": "Technical Support",
  "svc.productEng.item2": "Remote Administration",
  "svc.productEng.item3": "Training",

  "svc.secureAcademy.item1": "ATC Checkpoint",
  "svc.secureAcademy.item2": "ISC2 Official Training",

  // Industries
  "industry.banca": "Banking & Finance",
  "industry.telecom": "Telecom & ICT",
  "industry.seguros": "Insurance & AFP",
  "industry.mineria": "Mining, Energy & Hydrocarbons",
  "industry.gobierno": "Government",
  "industry.educacion": "Education",
  "industry.salud": "Healthcare & Pharmaceutical",
  "industry.retail": "Retail & E-commerce",
  "industry.manufactura": "Manufacturing",
  "industry.transporte": "Transportation & Logistics",
  "industry.otros": "Other Industries",

  // Trainings
  "training.ethicalHacking.category": "Technical Course",
  "training.ethicalHacking.title": "Advanced Ethical Hacking & Pentesting",
  "training.socAnalyst.category": "Certification",
  "training.socAnalyst.title": "SOC Analyst Level 1: Detection & Response",
  "training.cloudSecurity.category": "Workshop",
  "training.cloudSecurity.title": "Cloud Security for Corporate Enterprises",
  "training.secureAcademy.category": "Program",
  "training.secureAcademy.title": "Secure Academy: Continuous Cybersecurity Training",

  // Quick Actions
  "quick.elegirnos.title": "Why choose us?",
  "quick.elegirnos.subtitle": "Discover our competitive advantage",
  "quick.ubicacion.title": "Find us",
  "quick.ubicacion.subtitle": "America and Europe with direct presence",
  "quick.alertas.title": "Security alerts",
  "quick.alertas.subtitle": "Real-time global monitoring",
  "quick.consulta.title": "Quick quote",
  "quick.consulta.subtitle": "Custom pricing for your company",

  // Footer links
  "footer.link.nosotros": "About us",
  "footer.link.alertas": "Alerts & reports",
  "footer.link.partners": "Partners",
  "footer.link.denuncias": "Whistleblower Channel",
  "footer.link.politicas": "Corporate Policies",
  "footer.link.trabaja": "Work with us",
  "footer.link.soluciones": "Solutions",
  "footer.link.cotizar": "Request a quote",
  "footer.link.servicios": "Services",
  "footer.link.datacenter": "Datacenter",
  "footer.link.cybersoc": "CyberSOC",
  "footer.link.libro": "Complaints Book",
  "footer.link.datos": "Personal Data Processing",
  "footer.link.cookies": "Cookie Policy",
  "footer.link.privacidad": "Privacy Policy",
  "footer.link.terms": "Terms and Conditions",
  "footer.link.videovigilancia": "Video Surveillance Policy",
  "footer.link.sst": "OHS Policy",
  "footer.link.arcoManual": "ARCO Rights Manual",
  "footer.link.arcoForm": "ARCO Rights Request Form",
  "footer.link.osiptel": "OSIPTEL Complaints Filing Guide",
  "footer.link.reclamoForm": "Complaint Form",
  "footer.link.apelacionForm": "Appeal Form",
  "footer.link.quejaForm": "Grievance Form",
  "footer.link.cookiePrefs": "Cookie preferences",
  "footer.link.oficina": "Office",
  "footer.link.ejecutivo": "Contact an executive",

  // Certificaciones y Alianzas
  "cert.tag": "International backing",
  "cert.title": "Certifications &",
  "cert.highlight": "Partnerships",
  "cert.subtitle": "We work with world technology leaders to guarantee the highest quality solutions",

  // About
  "about.teamTitle": "We are Openlab Secure",
  "about.teamSubtitle": "A global team united by one mission",
  "about.tag": "Company",
  "about.title": "We protect what",
  "about.highlight": "you value most",
  "about.quote": "Over 200 specialists working to protect what you value most, with a direct presence in America and Europe.",
  "about.statCountries": "Countries",
  "about.statCountriesDesc": "America & Europe",
  "about.statSpecialists": "Specialists",
  "about.statSpecialistsDesc": "Certified",
  "about.statRating": "Rating",
  "about.statRatingDesc": "Prime Defense",
  "about.statMonitoring": "Monitoring",
  "about.statMonitoringDesc": "Active SOC",
  "about.valueTrust": "Trust",
  "about.valueTrustDesc": "We protect the most critical assets with integrity and transparency.",
  "about.valueInnovation": "Innovation",
  "about.valueInnovationDesc": "Cutting-edge technology and advanced methodologies to anticipate threats.",
  "about.valueCommitment": "Commitment",
  "about.valueCommitmentDesc": "Every client is a partner. Their security is our absolute priority.",
  "about.certificationsLabel": "Certifications",
  "about.isoCertified": "Certified",

  // Ecosystem
  "eco.tag": "Integrated solutions",
  "eco.title": "Solution",
  "eco.highlight": "Ecosystem",
  "eco.subtitle": "Six interconnected cybersecurity pillars protecting every layer of your digital infrastructure, from endpoint to cloud.",
  "eco.centerName": "Openlab Secure",
  "eco.explore": "Explore",
  "eco.tagline": "Each pillar strengthens the others · Holistic security architecture",

  // Services (section headers)
  "services.tag": "Solutions",
  "services.title": "Cybersecurity",
  "services.highlight": "Solutions",
  "services.subtitle": "We protect the most critical digital assets of leading organizations in Latin America with cutting-edge technology",
  "services.specialistsBar": "+200 specialists · 5 countries · 24/7",
  "services.servicesTitle": "Our",
  "services.servicesHighlight": "Cybersecurity Services",
  "services.servicesSubtitle": "From strategic consulting to continuous operations, we cover the full spectrum of your organization's digital security needs.",
  "services.viewSolution": "View solution",
  "services.viewService": "View service",
  "services.moreServices": "more services...",

  // Capacitaciones
  "training.title": "Secure Academy",
  "training.subtitle": "Training programs designed by our experts to strengthen your team's cybersecurity capabilities.",
  "training.students": "Students",
  "training.duration": "Duration",
  "training.rating": "Rating",
  "training.demand": "Demand level",
  "training.demandHigh": "High",
  "training.viewCourse": "View course",

  // Datacenter
  "dc.tag": "Infrastructure",
  "dc.title": "Datacenter",
  "dc.highlight": "Solutions",
  "dc.subtitle": "A comprehensive ecosystem of infrastructure and technology services to drive your organization's digital transformation",
  "dc.viewSolution": "View solution",
  "dc.exploreAll": "Explore all Datacenter solutions",

  // Industries (Our Clients)
  "industries.tag": "Sectors that trust us",
  "industries.title": "Our",
  "industries.highlight": "Clients",
  "industries.subtitle": "Over 200 organizations across 11 strategic sectors trust our world-class cybersecurity solutions",
  "industries.clickHint": "Click on any sector to see details",
  "industries.stat1": "+200 organizations",
  "industries.stat2": "11 strategic sectors",
  "industries.stat3": "5 countries · 2 continents",

  // CTA Banner
  "cta.tag": "Free consultation",
  "cta.title": "Openlab Secure provides solutions",
  "cta.highlight": "for every need",
  "cta.subtitle": "We make technology simplify your life while protecting every layer of your digital infrastructure with the highest security standards.",
  "cta.button": "Request free consultation",
  "cta.consultantName": "Samara Mendoza",
  "cta.consultantRole": "Consulting Director",
  "cta.response": "Response",
  "cta.responseTime": "< 15 min",

  "shared.ctaPrimary": "See more",
  "shared.ctaSecondary": "Talk to an expert",

  // Quick Actions
  "quick.title": "What do you want to do now?",
  "quick.viewMore": "View more",

  // Contact
  "contact.tag": "Get in touch",
  "contact.title": "Ready to",
  "contact.highlight": "protect yourself?",
  "contact.subtitle": "Our team of experts is ready to fortify your organization with top-tier solutions",
  "contact.email": "Email",
  "contact.availability": "Availability",
  "contact.availabilityValue": "Monday - Friday · 24/7 SOC",
  "contact.coverage": "Coverage",
  "contact.coverageValue": "America & Europe",
  "contact.followUs": "Follow us",
  "contact.fullname": "Full name",
  "contact.fullnamePlaceholder": "e.g. John Michael Smith",
  "contact.emailLabel": "Email",
  "contact.emailPlaceholder": "you@company.com",
  "contact.whatsapp": "WhatsApp",
  "contact.phone": "Phone (mobile)",
  "contact.phonePlaceholder": "+1 555 123 4567",
  "contact.ruc": "Tax ID",
  "contact.rucPlaceholder": "e.g. 12-3456789",
  "contact.company": "Company",
  "contact.companyPlaceholder": "Your company name",
  "contact.service": "Service of interest",
  "contact.serviceDefault": "Select a service",
  "contact.message": "Message (optional)",
  "contact.messagePlaceholder": "Tell us about your project or inquiry...",
  "contact.maxChars": "Maximum 500 characters",
  "contact.send": "Send message",
  "contact.sending": "Sending...",
  "contact.successTitle": "Message sent!",
  "contact.successMsg": "Thank you for contacting us. We will get back to you shortly.",
  "contact.sendAnother": "Send another message",
  "contact.errorDefault": "Error sending message. Please try again.",
  "contact.connectionError": "Connection error. Please try again later.",
  "contact.rateLimited": "Too many attempts in a row. Please wait a minute and try again.",
  "contact.consentPre": "By submitting, I accept the",
  "contact.consentAnd": "and the",

  // Contact page (internal)
  "contactPage.tag": "Contact us",
  "contactPage.title": "Let's talk about",
  "contactPage.highlight": "your company's security",
  "contactPage.subtitle": "Tell us your challenge and a specialist will get back to you with a tailored proposal within 24 hours.",
  "contactPage.scrollForm": "Go to the form",

  // Location map (Contact page)
  "location.tag": "Global presence",
  "location.title": "Our",
  "location.highlight": "Offices",
  "location.subtitle": "We ensure operational continuity in the face of any incident, minimizing the impact on our clients. Our coverage spans the country and the continent.",
  "location.intlTitle": "International Presence",
  "location.intlDesc": "Hover over the points",
  "location.nationalTitle": "National Coverage",
  "location.nationalDesc": "Hover over the points",
  "location.intlOfficesTitle": "International Offices",
  "location.nationalOfficesTitle": "National Offices",
  "location.intlOfficesSub": "Local teams in 5 countries",
  "location.nationalOfficesSub": "Presence in 3 cities nationwide",
  "location.teamLabel": "Local teams in 5 countries",
  "location.live": "Live",
  "location.exploreLabel": "Explore our network",
  "location.people.card1Title": "SOC Team 24/7",
  "location.people.card1Sub": "Behind every alert",
  "location.people.card2Title": "Field support",
  "location.people.card2Sub": "Close to your operation",
  "location.countryLabel": "countries",
  "location.siteLabel": "sites",
  "location.stat.countries": "Countries",
  "location.stat.countriesDesc": "Regional presence",
  "location.stat.sites": "Sites",
  "location.stat.sitesDesc": "Local operations",
  "location.stat.soc": "SOC 24/7",
  "location.stat.socDesc": "Continuous monitoring",
  "location.statLabel": "Our network in numbers",
  "location.country.pe": "Peru",
  "location.country.cl": "Chile",
  "location.country.ec": "Ecuador",
  "location.country.us": "USA",
  "location.country.co": "Colombia",
  "location.city.lima": "Lima",
  "location.city.santiago": "Santiago",
  "location.city.quito": "Quito",
  "location.city.miami": "Miami",
  "location.city.bogota": "Bogota",
  "location.city.arequipa": "Arequipa",
  "location.city.cusco": "Cusco",
  "location.role.hq": "Headquarters",
  "location.role.south": "Southern Regional Office",

  // Footer
  "footer.about": "About Openlab Secure",
  "footer.sales": "Sales & Procurement",
  "footer.contact": "Contact us",
  "footer.followUs": "Follow us",
  "footer.legal": "Legal",
  "footer.rights": "All rights reserved",
  "footer.tagline": "Cybersecurity Center of Excellence",

  // Cookies
  "cookies.title": "Your privacy matters",
  "cookies.description": "We use cookies and similar technologies to improve your experience, personalize content and analyze traffic. You can accept all, reject them or manage your preferences.",
  "cookies.accept": "Accept all",
  "cookies.reject": "Reject",
  "cookies.preferences": "Preferences",
  "cookies.prefsTitle": "Cookie preferences",
  "cookies.essential": "Essential cookies",
  "cookies.essentialDesc": "Necessary for the site to function properly. Cannot be disabled.",
  "cookies.alwaysOn": "Always on",
  "cookies.analytics": "Analytics cookies",
  "cookies.analyticsDesc": "Help us understand how you interact with the site to improve it.",
  "cookies.marketing": "Marketing cookies",
  "cookies.marketingDesc": "Allow us to show you relevant content and personalized advertising.",
  "cookies.cancel": "Cancel",
  "cookies.savePrefs": "Save preferences",
};